import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable react/no-multi-comp, react/display-name, react/prop-types */

import React from 'react';
import ReactMarkdown from 'react-markdown';
import RemarkBreaks from 'remark-breaks';
import RemarkGFM from 'remark-gfm';
import { Paragraph, Heading } from '@scentregroup/ui';
import { startsWith, deburr, get, kebabCase } from 'lodash';
import useFeatureFlag from '../../hooks/use-feature-flag';
import { FeatureFlagName } from '../../feature-flags';
import ResponsiveImage from '../responsive-image';
import Link from '../link';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_MARKDOWN_IMAGE_WIDTH = 1200;
const renderers = _ref => {
  let {
    dataTestId,
    paragraphType,
    isOnlineDecommissionMode
  } = _ref;
  return {
    root: _ref2 => {
      let {
        children
      } = _ref2;
      return /*#__PURE__*/_jsx("div", {
        className: style.Markdown,
        "data-test-id": dataTestId,
        "data-id": "markdown_index_renderers_div",
        children: children
      });
    },
    link: _ref3 => {
      let {
        title,
        href,
        children
      } = _ref3;
      if (startsWith(href, '#')) {
        return /*#__PURE__*/_jsx("a", {
          href: href,
          title: title,
          "data-id": "markdown_index_renderers_a",
          children: children
        });
      }
      if (isOnlineDecommissionMode) {
        if (/^(https:\/\/[^/]+)?\/shop\/(brand|collection|product)/.test(href)) {
          return children;
        }
        if (/^(https:\/\/[^/]+)?\/shop\/info\/(click-and-collect|delivery)/.test(href)) {
          return children;
        }
      }
      return /*#__PURE__*/_jsx(Link, {
        href: href,
        title: title,
        "data-id": "markdown_index_renderers_Link",
        children: children
      });
    },
    paragraph: _ref4 => {
      let {
        children
      } = _ref4;
      return /*#__PURE__*/_jsx(Paragraph, {
        type: paragraphType,
        "data-id": "markdown_index_renderers_Paragraph",
        children: children
      });
    },
    heading: _ref5 => {
      let {
        level,
        children
      } = _ref5;
      return /*#__PURE__*/_jsx(Heading, {
        type: {
          1: 'large',
          2: 'medium',
          3: 'small'
        }[level] || 'extrasmall',
        id: kebabCase(deburr(get(children, '[0].props.value', ''))),
        "data-id": "markdown_index_renderers_Heading",
        children: children
      });
    },
    image: _ref6 => {
      let {
        src,
        alt
      } = _ref6;
      return /*#__PURE__*/_jsx(ResponsiveImage, {
        lazyLoad: true,
        desktopImageUrl: src,
        mobileImageUrl: src,
        width: DEFAULT_MARKDOWN_IMAGE_WIDTH,
        alt: alt,
        "data-id": "markdown_index_renderers_ResponsiveImage"
      });
    },
    tableCell: _ref7 => {
      let {
        isHeader,
        children
      } = _ref7;
      return isHeader ? /*#__PURE__*/_jsx("th", {
        "data-id": "markdown_index_renderers_th",
        children: /*#__PURE__*/_jsx(Heading, {
          type: "extrasmall",
          "data-id": "markdown_index_renderers_th_Heading",
          children: children
        })
      }) : /*#__PURE__*/_jsx("td", {
        "data-id": "markdown_index_renderers_td",
        children: children
      });
    }
  };
};

// https://github.com/rexxars/react-markdown/blob/8ad8a995024a4729f066d109382b10c47d513379/src/renderers.js#L8
const Markdown = _ref8 => {
  let {
    content,
    dataTestId,
    paragraphType = 'large',
    customRenderers = _ => ({})
  } = _ref8;
  const isOnlineDecommissionMode = useFeatureFlag(FeatureFlagName.NEXT_PUBLIC_FEAT_FLAG_ONLINE_DECOMMISSION);
  const defaultRenderers = renderers({
    dataTestId,
    paragraphType,
    isOnlineDecommissionMode
  });
  return /*#__PURE__*/_jsx(ReactMarkdown, {
    skipHtml: true,
    source: content,
    plugins: [RemarkBreaks, RemarkGFM],
    className: style.Markdown,
    renderers: _objectSpread(_objectSpread({}, defaultRenderers), customRenderers(defaultRenderers)),
    "data-id": "markdown_index_renderers_ReactMarkdown"
  });
};
export default Markdown;